export const loadNews = () => {

    /*global AJAX*/

    $('#load-more-news').click(function(e) {

        e.preventDefault();

        let next = $(this).data('next');

        $('#spinner-news').removeClass('d-none');

        $.ajax({
            type: 'POST',
            // eslint-disable-next-line
            url: AJAX.url,
            data : {
                action: 'load_more_news',
                // eslint-disable-next-line
                nonce: AJAX.nonce,
                next : next,
            },
            success: function(result) {
                $('.loading-news').append(result.data);
                if(!result.load_more) {
                    $('#load-more-news').hide();
                }
                else {
                    $('#load-more-news').data('next', next+1);
                }
                $('#spinner-news').addClass('d-none');
            },
        });

    });

}
